import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import moment from 'moment'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
    Avatar,
    Box,
    Card,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    Chip,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
    IconButton,
    Modal,
    makeStyles,
    CircularProgress
} from '@material-ui/core'
import getInitials from '../../../utils/getInitials'
import {
    PersonAddRounded,
    PersonAddDisabledRounded,
    FileCopyRounded,
    Visibility,
    Delete
} from '@material-ui/icons'
import firebase from 'firebase/app'
import UserCard from '../../../components/UserCard'

const useStyles = makeStyles((theme) => ({
    root: {},
    avatar: {
        marginRight: theme.spacing(2)
    },
    userCard: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        maxHeight: '80%',
        maxWidth: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        overflowY: 'auto',
        boxShadow: theme.shadows[5]
    }
}))

const Results = (props) => {
    const {
        className,
        users,
        setUsers,
        page,
        setPage,
        limit,
        setLimit,
        // appendNewUsers,
        // noMoreData,
        ...rest
    } = props
    const classes = useStyles()
    const [selectedCustomerIds, setSelectedCustomerIds] = useState([])
    const [shownUsers, setShownUsers] = useState()
    const [postModalOpen, setPostModalOpen] = useState(false)
    const [selectedUser, setSelectedUser] = useState()

    function handleClose() {
        setPostModalOpen(false)
    }

    useEffect(() => {
        if (selectedUser && postModalOpen) {
            const itemRef = firebase.firestore().doc(`users/${selectedUser.id}`)

            const unsubscribe = itemRef.onSnapshot((doc) => {
                if (doc.exists) {
                    const _data = doc.data()

                    setSelectedUser({ ..._data, id: doc.id })
                }
            })
            // .then(() => console.log(selectedItem.dataType, 'SUCCEEDD'))
            // .catch((e) => console.log('ERROR', e))

            return () => unsubscribe()
        }
    }, [postModalOpen])

    useEffect(() => {
        const _shownUsers = users
            .slice(0 + limit * page, limit * (page + 1))
            .map((user) => user.id)

        setShownUsers(_shownUsers)
    }, [limit, page, users])

    const handleSelectAll = (event) => {
        let newSelectedCustomerIds

        if (event.target.checked) {
            newSelectedCustomerIds = users
                .slice(0 + limit * page, limit * (page + 1))
                .map((user) => user.id)
        } else {
            newSelectedCustomerIds = []
        }

        setSelectedCustomerIds(newSelectedCustomerIds)
    }

    const handleSelectOne = (event, id) => {
        const selectedIndex = selectedCustomerIds.indexOf(id)
        let newSelectedCustomerIds = []

        if (selectedIndex === -1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds,
                id
            )
        } else if (selectedIndex === 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(1)
            )
        } else if (selectedIndex === selectedCustomerIds.length - 1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(0, -1)
            )
        } else if (selectedIndex > 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(0, selectedIndex),
                selectedCustomerIds.slice(selectedIndex + 1)
            )
        }

        setSelectedCustomerIds(newSelectedCustomerIds)
    }

    const handleLimitChange = (event) => {
        setLimit(event.target.value)
        // veri yuklenmeden bos sayfaya gitmemek icin -25 onlem
        if (
            users.length >= 25 &&
            event.target.value * page > users.length - 25
        ) {
            const _newPage = Math.floor(
                (users.length - 25) / event.target.value
            )

            setPage(_newPage)
        }
    }

    const handlePageChange = (event, newPage) => {
        setPage(newPage)
    }

    async function makeUserDisable(id) {
        const updateStatus = firebase
            .firestore()
            .doc(`users/${id}`)
            .update({ disabled: true, banned: true })

        const updateAuthStatus = firebase
            .functions()
            .httpsCallable('disableUser-DisableUser')({
            id,
            status: true
        })

        await Promise.all([updateStatus, updateAuthStatus])
            .then(() => {
                const updatedUsers = users.map((user) => {
                    if (user.id === id) {
                        return {
                            ...user,
                            banned: true,
                            disabled: true
                        }
                    } else return user
                })
                setUsers(updatedUsers)
            })
            .catch((e) => console.log('ERRORRR', e))
    }

    async function makeUserEnable(id) {
        const updateStatus = firebase
            .firestore()
            .doc(`users/${id}`)
            .update({ disabled: false, banned: false })

        const updateAuthStatus = firebase
            .functions()
            .httpsCallable('disableUser-DisableUser')({
            id,
            status: false
        })

        await Promise.all([updateStatus, updateAuthStatus]).then(() => {
            const updatedUsers = users.map((user) => {
                if (user.id === id) {
                    return {
                        ...user,
                        banned: false,
                        disabled: false
                    }
                } else return user
            })
            setUsers(updatedUsers)
        })
    }

    function banUser(user) {
        if (
            window.confirm(
                `Do you really want to ${
                    user.disabled === false ? 'ban' : 'enable'
                } the user?`
            )
        ) {
            user.disabled === false
                ? makeUserDisable(user.id)
                : makeUserEnable(user.id)
        }
    }

    function deleteUser(id) {
        if (
            window.confirm(
                'Do you really want to delete the user? This action cannot be undone later.'
            )
        ) {
            return firebase
                .functions()
                .httpsCallable('deleteUser-DeleteUser')(id)
                .then(() => {
                    const updatedUsers = users.map((user) => {
                        if (user.id === id) {
                            return {
                                ...user,
                                deleted: true,
                                disabled: true
                            }
                        } else return user
                    })
                    setUsers(updatedUsers)
                })
                .catch((e) => console.log('DELETED FAILED', e))
        }
    }

    return (
        <>
            <Card className={clsx(classes.root, className)} {...rest}>
                <PerfectScrollbar>
                    <Box minWidth={1050}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            checked={
                                                JSON.stringify(
                                                    selectedCustomerIds
                                                ) === JSON.stringify(shownUsers)
                                            }
                                            color="primary"
                                            indeterminate={false}
                                            onChange={handleSelectAll}
                                        />
                                    </TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Reports Count</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Location</TableCell>
                                    <TableCell>Registration Date</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {users
                                    .slice(0 + limit * page, limit * (page + 1))
                                    .map((user) => (
                                        <TableRow
                                            hover
                                            key={user.id}
                                            selected={selectedCustomerIds.includes(
                                                user.id
                                            )}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    checked={selectedCustomerIds.includes(
                                                        user.id
                                                    )}
                                                    onChange={(event) =>
                                                        handleSelectOne(
                                                            event,
                                                            user.id
                                                        )
                                                    }
                                                    value="true"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Box
                                                    alignItems="center"
                                                    display="flex"
                                                >
                                                    <Avatar
                                                        className={
                                                            classes.avatar
                                                        }
                                                        src={user.photoURL}
                                                    >
                                                        {getInitials(user.name)}
                                                    </Avatar>
                                                    <div>
                                                        <Typography
                                                            color="textPrimary"
                                                            variant="body1"
                                                        >
                                                            {user.name}
                                                            {'  '}
                                                            {user.surname}
                                                        </Typography>
                                                        <Typography
                                                            color="textSecondary"
                                                            style={{
                                                                fontSize: 12
                                                            }}
                                                        >
                                                            {user.id}
                                                            <IconButton
                                                                title="Copy Id"
                                                                style={{
                                                                    marginLeft: 4
                                                                }}
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(
                                                                        user.id
                                                                    )
                                                                }}
                                                            >
                                                                <FileCopyRounded />
                                                            </IconButton>
                                                        </Typography>
                                                    </div>
                                                </Box>
                                            </TableCell>

                                            <TableCell>
                                                <Chip
                                                    color={
                                                        !user.disabled
                                                            ? 'primary'
                                                            : 'default'
                                                    }
                                                    label={
                                                        user.disabled
                                                            ? 'disable'
                                                            : 'active'
                                                    }
                                                    size="small"
                                                />
                                                {user?.banned ? (
                                                    <Chip
                                                        //  color="default"
                                                        label="banned"
                                                        size="small"
                                                        style={{
                                                            marginLeft: 4,
                                                            backgroundColor:
                                                                'red'
                                                        }}
                                                    />
                                                ) : null}
                                                {user?.deleted ? (
                                                    <Chip
                                                        //  color="default"
                                                        label="deleted"
                                                        size="small"
                                                        style={{
                                                            marginLeft: 4,
                                                            backgroundColor:
                                                                'turquoise'
                                                        }}
                                                    />
                                                ) : null}
                                            </TableCell>
                                            <TableCell>
                                                {user.reportCount}
                                            </TableCell>
                                            <TableCell>{user.email}</TableCell>
                                            <TableCell>{`${user.coordinatesName}`}</TableCell>
                                            <TableCell>
                                                {moment(
                                                    user?.metadata?.createDate?.toDate()
                                                ).format('HH:mm, DD/MM/YYYY')}
                                            </TableCell>
                                            <TableCell>
                                                <IconButton
                                                    onClick={() => {
                                                        setSelectedUser(user)
                                                        setPostModalOpen(true)
                                                    }}
                                                >
                                                    <Visibility />
                                                </IconButton>
                                                {!user?.deleted ? (
                                                    <IconButton
                                                        title={
                                                            user.disabled ===
                                                            false
                                                                ? 'Ban User'
                                                                : 'Enable User'
                                                        }
                                                        onClick={() =>
                                                            banUser(user)
                                                        }
                                                    >
                                                        {user.disabled ===
                                                        false ? (
                                                            <PersonAddDisabledRounded />
                                                        ) : (
                                                            <PersonAddRounded />
                                                        )}
                                                    </IconButton>
                                                ) : null}
                                                {!user?.deleted ? (
                                                    <IconButton
                                                        onClick={() =>
                                                            deleteUser(user.id)
                                                        }
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                ) : null}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </Box>
                </PerfectScrollbar>
                <TablePagination
                    component="div"
                    count={users.length}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleLimitChange}
                    page={page}
                    rowsPerPage={limit}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </Card>
            <Modal
                // disableBackdropClick={!!loading}
                open={postModalOpen}
                onClose={handleClose}
                aria-labelledby="selected-post-modal"
                aria-describedby="selected-post-modal-description"
            >
                <>
                    {selectedUser ? (
                        <UserCard
                            className={classes.userCard}
                            user={selectedUser}
                            list={users}
                            setUsers={setUsers}
                        />
                    ) : (
                        <CircularProgress />
                    )}
                </>
            </Modal>
        </>
    )
}

Results.propTypes = {
    className: PropTypes.string,
    users: PropTypes.array.isRequired,
    setUsers: PropTypes.func,
    limit: PropTypes.number,
    setLimit: PropTypes.func,
    page: PropTypes.number,
    setPage: PropTypes.func,
    appendNewUsers: PropTypes.func,
    noMoreData: PropTypes.bool
}

export default Results
